import { BaseEntity } from "../common/baseEntity";
import { OrderItem } from "./orderItem";
import { OrderStatus } from "./orderStatus";
import { Customer } from "../customers/customer";
import { OrderTotal } from "./orderTotal";
import { Location } from "../management/locationManagement/location";
import { PdaType } from "./PdaType";
import { CalculatorType } from "./calculatorType";
import { CanadianCurrencyCode } from "../currencyExchange/canadianCurrencyCode";
import { OrderOptions } from "./orderOptions";
import { CalculatorHelper } from "../../common/helpers/calculatorHelper";
import { OrderContentData } from "./orderContentData";
import { OrderContent } from "./orderContent";
import { OrderLocation } from "../management/order/orderLocation";
import { HowQuicklyImportType } from "./how-quickly-import-type";

/**
 * Created by alex.y on 8/8/2017.
 */
export class Order extends BaseEntity<number> {
    public OrderItems: Array<OrderItem> = [];
    public Status: OrderStatus;
    public CustomerId: number;
    public Customer: Customer = new Customer();
    public Locations: Array<OrderLocation> = [];
    public IsCommercial: boolean = false;
    public IsNeedShippingHelp: boolean = false;
    public NumberOfLines: number;
    public Currency: CanadianCurrencyCode;
    public Flag: OrderOptions;
    public CalculatorType: CalculatorType;
    public DataList: Array<OrderContent> = new Array<OrderContent>();
    public Totals: SimpleOrderTotal;
    public CarryingType: number;
    public Source: string;
    public HowQuicklyImportType: HowQuicklyImportType;
}


export class SimpleOrderTotal {
    public Id: number;
    public GrandTotalPayable: number;
    public TotalValueForCustoms: number;
    public TotalValueOfProduct: number;
    public BorderBuddyCustoms: number;
}

export class ESOrder extends BaseEntity<number> {
    public Status: OrderStatus;
    public IsCommercial: boolean = false;
    public IsNeedShippingHelp: boolean = false;
    public NumberOfLines: number;
    public TotalCurrencyName: string;
    public CurrencyName: string;
    public Flag: OrderOptions;
    public CarryingType: number;
    public Source: string;
}



// WEBPACK FOOTER //
// ./app/objects/orders/order.ts